

export const apiPath = {
    base_url: `/assistant-ai/bot`,
    input: "/resume-interview/v2/question",
    next_question: "/resume-interview/v2/question/next",
    tts: "/resume-interview/tts",
    stt: "/resume-interview/stt",
    result_url: "/resume-interview/v2/result",
    save_email: "/resume-interview/profile",
    sign_in: "/sign-in",
    room: {
        verify: "/client/interview/verify",
        publicCandidate: "/public/verify-room",
        trackInviteEmailLink: "/public/track-invite-email-link",
        detail: "/client/interview",
        save_questions_bank: "/save/question-bank",
        check_questions_bank: "/check/question-bank",
        std_assessment: "/company/std-assessment/public",
        report: "/report",
        email_admin: "/email/interview/complete_interview",
        emotional_image: "/summary-snapshot"
       
    },
    quiz:{
        hard_skill: "/public/interview-question/hard-skill"
    },
    report_audio: "/report-audio"

}